module.exports = __webpack_public_path__ + "img/freestyle_box10.3a94840d.jpg";